import { useState } from 'react';
import { read_cookie } from "sfcookies";
import { hostUrl } from "../../../../utils/url-manager";

export const useCustomerAccountCreditManager: () => {
    loading: boolean,
    processCreditUpdate: (customerAccountId: string, credits: number) => Promise<void>,
} = (): {
    loading: boolean,
    processCreditUpdate: (customerAccountId: string, credits: number) => Promise<void>,
} => {
    const [loading, setLoading] = useState<boolean>(false);

    async function processCreditUpdate(customerAccountId: string, credits: number): Promise<void> {
        setLoading(true);
        const url: string = hostUrl + 'hq/customer/account/credits';
        const token: string = read_cookie('auth');
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify({customerAccountId: customerAccountId, credits: credits}),
            headers: new Headers({
                'Content-Type': 'application/json',
                'token': token,
            })
        });
        return fetch(request)
            .then( (response: Response): Promise<any> => {
                setLoading(false);
                return response.json();
            })
            .catch((error: Error): void => {
                console.error(error);
            })
    }

    return { loading, processCreditUpdate }
}